import { Route, Routes, useLocation } from "react-router";
import { useUser } from "../../contexts/UserContext";
import { lazy, Suspense, useEffect, useState } from "react";
import { API } from "../../config/api";
import DefaultLoader from "../loaders/default-loader";
import { LocalStorage } from "../../config/localstorage";
import Unregister from "../../pages/unregister";
import Condition from "../../pages/condition";
import { useNotifications } from "../../hooks/useNotifications";

const Home = lazy(() => import("../../pages/home"));
const Homepage = lazy(() => import("../../pages/homepage"));
const Details = lazy(() => import("../../pages/details"));
const Partner = lazy(() => import("../../pages/partner"));
const Register = lazy(() => import("../../pages/register"));
const Login = lazy(() => import("../../pages/login"));
const Dashboard = lazy(() => import("../../pages/dashboard"));
const ReservationFollowup = lazy(() => import("../../pages/reservation-followup"))
const ReservationReview = lazy(() => import("../../pages/reservation-review"))
const HouseDetails = lazy(() => import("../../pages/house-details"))
const Profile = lazy(() => import("../../pages/profile"))
const Support = lazy(() => import("../../pages/support"))

export const Navigation = () => {
  const [isLoading, setIsLoading] = useState(true);
  const { user, setUser } = useUser();
  const location = useLocation();
  useNotifications();

  useEffect(() => {
    verifyToken();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (user) {
      setIsLoading(false);
    }
  }, [user]);

  const verifyToken = async () => {
    try {
      const token = LocalStorage.getLocalStorageItem("token");
      if (token) {
        const response = await API.RefreshToken(token);
        const { data, success } = response.data;
        if (success) {
          LocalStorage.setLocalStorageItem("token", data.access_token);
          setUser(data);
        } else {
          setIsLoading(false);
        }
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Token verification failed:", error);
    }
  };

  return (
    <>
      {isLoading ? (
        <DefaultLoader />
      ) : (
        <Suspense key={location.pathname} fallback={<DefaultLoader />}>
          <Routes>
            <Route path="/" element={<Homepage />} />
            <Route path="/home" element={<Home />} />
            <Route path="/details/:code" element={<Details />} />
            <Route path="/partner" element={<Partner />} />
            <Route path="/register" element={<Register />} />
            <Route path="/unregister" element={<Unregister />} />
            <Route path="/login" element={<Login />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/reservation/:code" element={<ReservationFollowup />} />
            <Route path="/reservation/:code/review" element={<ReservationReview />} />
            <Route path="/condition" element={<Condition />} />
            {/* <Route path="/listings" element={<Homepage />} /> */}
            <Route path="/house/:code" element={<HouseDetails />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/support" element={<Support />} />
          </Routes>
        </Suspense>
      )}
    </>
  );
};
